// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"7374f8d1","496":"8d8889c6","647":"625a4b6e"}[chunkId] + ".chunk.js";
};